import {
  RECEIVED_POSTS,
  LOADING_POSTS,
  SET_SORT,
  DELETING_POSTS
} from "types/actions/posts"
import { SortBy } from "../actions/posts"
import { UPDATE_POST } from "types/actions/posts"
const { BY_DATE } = SortBy

const postsIntialState = {
  data: [],
  sort: BY_DATE,
  isLoading: false,
  isDeleting: false
}

export default (state = postsIntialState, action) => {
  switch (action.type) {
    case RECEIVED_POSTS:
      return {
        ...state,
        data: [...action.data]
      }
    case LOADING_POSTS:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case DELETING_POSTS:
      return {
        ...state,
        isDeleting: !state.isDeleting
      }
    case SET_SORT:
      return {
        ...state,
        sort: action.sort
      }
    case UPDATE_POST:
      return {
        ...state,
        data: state.data.map(x => {
          if (x.id === action.id) {
            x = {
              ...x,
              ...action.updates
            }
          }
          return x
        })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/posts.js